<template>
  <v-row>
    <v-col cols="12" lg="3" md="4">
      <v-card :loading="loading" class="elevation-12">
        <v-card-text>
          <v-sheet class="pa-2 primary">
            <v-text-field
                v-model="search"
                label="Поиск пользователя"
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
                dense
            />
          </v-sheet>
        </v-card-text>

        <v-card-text v-if="account">
          <v-treeview
              :items="[account]"
              item-text="name"
              item-children="childs"
              dense
              hoverable
              color="error"
              activatable

              :return-object="true"
              :active.sync="active"
              :search="search"
              :filter="filter"
          >
          </v-treeview>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-dialog v-model="createAccountDialog" persistent max-width="960px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                Новый пользователь
              </v-btn>
            </template>

            <CreateAccount @cancel="onCreateAccountCanceled" ref="createAccount"/>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" lg="9" md="8" v-if="selectedLogin">
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              Основные данные
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="selectedLogin.username"
                            label="Логин"
                            :disabled="true"/>

              <v-text-field v-model="nameForm.name"
                            label="ФИО"
                            :error-messages="nameError"
                            :counter="500"
              />
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" @click="onChangeNameClicked">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="pt-0">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              Смена пароля
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="passwordForm.password"
                            type="password"
                            label="Пароль"
                            :error-messages="passwordErrorMessages"
              />

              <v-text-field v-model="passwordForm.passwordRepeat"
                            type="password"
                            label="Пароль ещё раз"
                            :error-messages="passwordRepeatErrorMessages"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" @click="onChangePasswordClicked">Сменить пароль</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="elevation-12" v-if="selectedLogin.username !== $store.getters.appLogin.username"
                  width="100%">
            <v-tabs v-model="tab" grow>
              <v-tab key="General">
                Общие
              </v-tab>
              <v-tab key="Regions">
                Области
              </v-tab>
              <v-tab key="Areas">
                Районы
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="General">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-card>
                      <v-card-text>
                        <v-select v-model="selectedLogin.type"
                                  :items="typeOptions"
                                  :item-text="item => item.name"
                                  :item-value="item => item"
                                  label="Тип пользователя"
                                  dense
                        />

                        <v-text-field v-model="selectedLogin.postIndex" v-if="isSelectedLoginPostIndexEditable"
                                      label="Код постового отделения"
                                      :maxlength="6"
                                      :counter="6"
                                      :error-messages="selectedLoginPostIndexErrors"
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card>
                      <v-card-text>
                        <v-checkbox
                          v-model="allSelected"
                          @change="selectAllPermissionsChanged"
                          label="Выбрать все" dense
                          :hide-details="true">
                        </v-checkbox>
                        <br><hr><br>
                        <v-checkbox
                            v-for="item in selectedLogin.allowedPermissions"
                            v-model="item.allowed"
                            :label="item.permission.name"
                            :key="item.permission.id"
                            flat
                            dense
                            class="mt-1 pa-1"
                            :hide-details="true"
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item key="Regions"
              >
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      v-model="allSelectedRegions"
                      @change="selectAllRegionsChanged"
                      label="Выбрать все" dense
                      :hide-details="true">
                    </v-checkbox>
                    <br><hr><br>
                    <v-row>
                      <v-col cols="12" md="3" lg="2" class="pa-0" v-for="item in selectedLogin.allowedRegions"
                             :key="item.region.id">
                        <v-checkbox
                            v-model="item.allowed"
                            :label="item.region.name"
                            flat
                            dense
                            class="mt-1 pa-1"
                            :hide-details="true"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="Areas"
              >
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      v-model="allSelectedAreas"
                      @change="selectAllAreasChanged"
                      label="Выбрать все" dense
                      :hide-details="true">
                    </v-checkbox>
                    <br><hr><br>
                    <v-row>
                      <v-col v-for="item in selectedLogin.allowedAreas" cols="12" md="3" lg="2" :key="item.area.id"
                             class="pa-0">
                        <v-checkbox
                            v-model="item.allowed"
                            :label="item.area.name"
                            flat
                            dense
                            class="mt-1 pa-1"
                            :hide-details="true"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" @click="onSaveSelectedLoginClicked">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-snackbar v-model="isSuccessPasswordChanged"
                :timeout="5000"
                :top="true"
                color="info"
    >
      Новый пароль успешно сохранен
    </v-snackbar>
    <v-snackbar v-model="isFailedChangePassword"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить новый пароль
    </v-snackbar>

    <v-snackbar v-model="isSuccessNameChanged"
                :timeout="5000"
                :top="true"
                color="info"
    >
      ФИО успешно сохранён
    </v-snackbar>
    <v-snackbar v-model="isFailedChangeName"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить новый ФИО
    </v-snackbar>

    <v-snackbar v-model="isSuccessAccountChanged"
                :timeout="5000"
                :top="true"
                color="info"
    >
      Данные пользователя успешно обновлены
    </v-snackbar>
    <v-snackbar v-model="isFailedChangeAccount"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить данные пользователя
    </v-snackbar>
  </v-row>
</template>

<script>
import AccountService from '@/services/account.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import Mappers from '@/mappers'
import {maxLength, minLength, required, sameAs, requiredIf, numeric} from 'vuelidate/lib/validators'
import _ from "underscore";
import {AllowAccountsManagement} from "@/enums/permission";
import {Admin, PostOfficeRegionAdmin, PostOfficeAreaOperator, PostOfficeOperator} from "@/enums/account.type";
import CreateAccount from "@/components/CreateAccount";
import {APP_ACCOUNT_CREATE_FAILED, APP_ACCOUNT_CREATED} from "@/events/app";

export default {
  name: "UsersManagementView",
  components: {
    CreateAccount
  },
  data() {
    return {
      createAccountDialog: false,

      account: null,
      loading: false,
      search: null,
      active: [],

      // change account
      selectedLogin: null,
      typeOptions: [Admin, PostOfficeRegionAdmin, PostOfficeAreaOperator, PostOfficeOperator],
      tab: null,
      isSuccessAccountChanged: false,
      isFailedChangeAccount: false,


      // change password
      passwordForm: {
        password: '',
        passwordRepeat: ''
      },
      isSuccessPasswordChanged: false,
      isFailedChangePassword: false,


      // change name
      nameForm: {
        name: ''
      },
      isSuccessNameChanged: false,
      isFailedChangeName: false,

      // create account
      isSuccessAccountCreated: false,
      isAccountCreatedFailed: false,

      // select all
      allSelected: false,
      allSelectedAreas: false,
      allSelectedRegions: false
    }
  },
  validations: {
    passwordForm: {
      password: {
        required
      },
      passwordRepeat: {
        required,
        sameAs: sameAs(function () {
          return this.passwordForm.password
        })
      }
    },
    nameForm: {
      name: {
        required,
        maxLength: maxLength(500)
      }
    },
    selectedLogin: {
      type: {
        required: required
      },
      postIndex: {
        required: requiredIf(model => {
          return model?.type === PostOfficeOperator
        }),
        minLength: minLength(6),
        maxLength: maxLength(6),
        format: numeric
      }
    }
  },
  computed: {
    filter() {
      return (item, search, textKey) => {
        return item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1
      }
    },
    passwordErrorMessages() {
      const errors = []

      if (this.$v.passwordForm.password.$dirty)
        !this.$v.passwordForm.password.required && errors.push('Введите новый пароль')

      return errors
    },
    passwordRepeatErrorMessages() {
      const errors = []

      if (this.$v.passwordForm.passwordRepeat.$dirty) {
        if (!this.$v.passwordForm.passwordRepeat.required) {
          errors.push('Введите новый пароль ещё раз')
        } else {
          !this.$v.passwordForm.passwordRepeat.sameAs && errors.push(`Не совпадает`)
        }
      }

      return errors
    },
    nameError() {
      const errors = []

      if (this.$v.nameForm.name.$dirty) {
        if (!this.$v.nameForm.name.required) {
          errors.push('Введите ФИО')
        } else {
          !this.$v.nameForm.name.maxLength && errors.push(`Слишком длинное`)
        }
      }

      return errors
    },
    selectedLoginPostIndexErrors() {
      const errors = []

      if (this.$v.selectedLogin.$dirty) {
        if (!this.$v.selectedLogin.postIndex.required) {
          errors.push('Введите пост-индекс отделения')
        } else {
          !this.$v.selectedLogin.postIndex.minLength && errors.push('Введите номер почтового отделения польность - 6 цифр')
          !this.$v.selectedLogin.postIndex.maxLength && errors.push('Слишком длинный номер почтового отделения')
          !this.$v.selectedLogin.postIndex.format && errors.push('Номер почтового отделения должен состоять из 6 цифр')
        }
      }

      return errors
    },


    isAllowUserManagements() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowAccountsManagement
      })
    },
    isSelectedLoginPostIndexEditable() {
      return this.selectedLogin && this.selectedLogin.type === PostOfficeOperator
    }
  },
  methods: {
    selectAllPermissionsChanged() {
      const selected = this.allSelected;
      for (let i = 0; i < this.selectedLogin.allowedPermissions.length; i++) {
        this.selectedLogin.allowedPermissions[i].allowed = selected;
      }
    },
    selectAllRegionsChanged() {
      const selected = this.allSelectedRegions;
      for (let i = 0; i < this.selectedLogin.allowedRegions.length; i++) {
        this.selectedLogin.allowedRegions[i].allowed = selected;
      }
    },
    selectAllAreasChanged() {
      const selected = this.allSelectedAreas;
      for (let i = 0; i < this.selectedLogin.allowedAreas.length; i++) {
        this.selectedLogin.allowedAreas[i].allowed = selected;
      }
    },
    loadAccounts() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      AccountService.getTree()
          .then(response => {
            this.account = Mappers.mapAccount(response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onChangePasswordClicked() {
      this.$v.passwordForm.$touch()

      if (!this.$v.passwordForm.$invalid && this.selectedLogin) {

        this.isSuccessPasswordChanged = false
        this.isFailedChangePassword = false

        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)
        AccountService.changePassword({
          username: this.selectedLogin.username,
          password: this.passwordForm.password
        })
            .then(() => {
              this.isSuccessPasswordChanged = true

              this.passwordForm.password = null
              this.passwordForm.passwordRepeat = null
              this.$v.passwordForm.$reset()
            }, () => {
              this.isFailedChangePassword = true
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onChangeNameClicked() {
      this.$v.nameForm.$touch()

      if (!this.$v.nameForm.$invalid && this.selectedLogin) {
        this.isSuccessNameChanged = false
        this.isFailedChangeName = false

        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)
        AccountService.changeName({
          username: this.selectedLogin.username,
          name: this.nameForm.name
        })
            .then(() => {
              this.isSuccessNameChanged = true

              this.$v.nameForm.$reset()
            }, () => {
              this.isFailedChangeName = true
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onSaveSelectedLoginClicked() {
      this.$v.selectedLogin.$touch()

      if (!this.$v.selectedLogin.$invalid && this.selectedLogin) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.isSuccessAccountChanged = false
        this.isFailedChangeAccount = false

        AccountService.changeAccount({
          username: this.selectedLogin.username,
          permissions: _.map(_.filter(this.selectedLogin.allowedPermissions, ap => {
            return ap.allowed
          }), ap => {
            return ap.permission
          }),
          region: _.map(_.filter(this.selectedLogin.allowedRegions, ar => {
            return ar.allowed
          }), ar => {
            return ar.region
          }),
          areas: _.map(_.filter(this.selectedLogin.allowedAreas, aa => {
            return aa.allowed
          }), aa => {
            return aa.area
          }),
          accountType: this.selectedLogin.type,
          postIndex: this.selectedLogin.postIndex
        })
            .then(() => {
              this.isSuccessAccountChanged = true
            }, () => {
              this.isFailedChangeAccount = true
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onCreateAccountCanceled() {
      this.createAccountDialog = false
    },

    onAccountCreated() {
      this.$refs.createAccount.clear()
      this.createAccountDialog = false
      this.isSuccessAccountCreated = true

      this.loadAccounts()
    },
    onAccountCreateFailed() {
      this.isAccountCreatedFailed = true
    }
  },
  created() {
    this.$bus.$on(APP_ACCOUNT_CREATED, this.onAccountCreated)
    this.$bus.$on(APP_ACCOUNT_CREATE_FAILED, this.onAccountCreateFailed)

    if (this.isAllowUserManagements) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Управление пользователями')
      this.loadAccounts()
    } else
      this.$router.go(-1)
  },
  beforeDestroy() {
    this.$bus.$off(APP_ACCOUNT_CREATED, this.onAccountCreated)
    this.$bus.$off(APP_ACCOUNT_CREATE_FAILED, this.onAccountCreateFailed)
  },
  watch: {
    "active"() {
      this.selectedLogin = null

      this.$v.selectedLogin.$reset()
      this.$v.passwordForm.$reset()
      this.$v.nameForm.$reset()

      this.tab = null
      if (this.active.length) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)
        AccountService.getLogin(this.active[0].username)
            .then(response => {
              this.tab = 'General'
              this.selectedLogin = Mappers.mapLogin(response.data)

              this.selectedLogin.allowedRegions = _.map(this.$store.getters.appLogin.regions, region => {
                return {
                  region: region,
                  allowed: !!_.find(this.selectedLogin.regions, r => {
                    return r.id === region.id
                  })
                }
              })
              this.selectedLogin.allowedAreas = _.map(this.$store.getters.appLogin.areas, area => {
                return {
                  area: area,
                  allowed: !!_.find(this.selectedLogin.areas, a => {
                    return a.id === area.id
                  })
                }
              })
              this.selectedLogin.allowedPermissions = _.map(this.$store.getters.appLogin.permissions, permission => {
                return {
                  permission: permission,
                  allowed: !!_.find(this.selectedLogin.permissions, p => {
                    return p.id === permission.id
                  })
                }
              })

              this.nameForm.name = this.selectedLogin.name

              this.passwordForm.password = null
              this.passwordForm.passwordRepeat = null
            })
            .finally(() => {
              this.loading = false;
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  }
}
</script>

<style scoped>
.v-tab.v-tab--active {
  background-color: #1976d2;
  color: #fff
}
</style>
